const load_more_race_blogs = () => {
    var loadMoreButton = document.querySelector('.load-more');
    var newestRaces = document.querySelectorAll('.newer-race-blog-card');
    var oldestRaces = document.querySelectorAll('.older-race-blog-card');
    var visibleNewest = 2;
    var visibleOldest = 4;

    function toggleRacesVisibility(races, startIndex, count, show) {
        for (var i = startIndex; i < startIndex + count; i++) {
            if (races[i]) {
                races[i].style.display = show ? 'flex' : 'none';
            }
        }
    }

    toggleRacesVisibility(newestRaces, 0, newestRaces.length, false);
    toggleRacesVisibility(oldestRaces, 0, oldestRaces.length, false);

    toggleRacesVisibility(newestRaces, 0, visibleNewest, true);
    toggleRacesVisibility(oldestRaces, 0, visibleOldest, true);

    loadMoreButton.addEventListener('click', function () {
        visibleNewest += 2;
        toggleRacesVisibility(newestRaces, 0, visibleNewest, true);

        visibleOldest += 2;
        toggleRacesVisibility(oldestRaces, 0, visibleOldest, true);

        if (visibleNewest >= newestRaces.length && visibleOldest >= oldestRaces.length) {
            loadMoreButton.style.display = 'none';
        }
    });
}

export default load_more_race_blogs;